module.exports = __webpack_public_path__ + "static/media/sejseli.8ff7db0e.jpg";